export default __webpack_public_path__ + "static/media/jaipur3.e9a3a1be.jpg";